import React from 'react';
import styles from './AbstractSaleDetailsForm.module.scss';
import * as Yup from "yup";
import {calculateMinimum, calculatePercentageOffAskingPrice} from 'data/utils/calculators';
import PriceSelector from './components/priceSelector';
import {Grid} from '@material-ui/core';
import EditorSection from '../editorSection';
import {ISaleDetails} from 'data/interfaces/products';
import AbstractDetailsForm from '../abstractDetailsForm';

interface IAbstractSaleDetailsFormProps {
  valuePrice?: number;
  changePrice?: number;
  currency?: number;
  saleDetails?: Partial<ISaleDetails>;

  commonFormComponents?: any;
  infoComponent?: any;

  setSubmitRef?: any;
  onSubmit: (formValues, options?: any) => Promise<any>;
  activeStep?: number;
  loading?: boolean;
}

const yupSchema = Yup.object({
  askingPrice: Yup.number()
    .required("יש לבחור מחיר")
    .min(1, "מכירה צריך להיות גבוהה מ-1")
    .max(999999, "מכירה צריך להיות נמוך מ-999999"),
  currency: Yup.number().min(1).max(10).required("יש לבחור מטבע"),
});

const AbstractSaleDetailsForm = (props: IAbstractSaleDetailsFormProps) => {
  const minPossiblePrice = calculateMinimum(props.changePrice);
  return (<Grid className={styles.SaleDetailsForm} container spacing={2}>
    <EditorSection loading={props.loading} title="קבע מחיר מכירה" titleClassName={styles.choocePriceTitle}>
      <Grid item xs={12} style={{marginTop: 7}}>
        <AbstractDetailsForm
          {...props}
          yupSchemaObject={yupSchema}
          initialValues={{
            askingPrice: calculatePercentageOffAskingPrice(props.valuePrice, 75),
            activeStep: 1,
            allowPurchaseOfSingleTickets: false,
            ...props.saleDetails,
            currency: props.currency
          }}
          onSubmit={(async (values, options) => {
            
            if (values.activeStep < 1 || values.activeStep < props.activeStep) {
              await props
                .onSubmit({activeStep: values.activeStep}, options);
            } else {
              await props
                .onSubmit(values, options);
            }
          }) as any}
          formComponents={({setFieldValue, values}) => <>
            <PriceSelector
              changePrice={props.changePrice}
              askingPrice={values.askingPrice}
              valuePrice={props.valuePrice}
              currency={props.currency}
              setAskingPrice={askingPrice => setFieldValue("askingPrice", askingPrice)}
            />
          </>}
        />
      </Grid>
    </EditorSection>
  </Grid>);
};

AbstractSaleDetailsForm.defaultProps = {
  valuePrice: 0,
  changePrice: 0,
  currency: 0,
  onSubmit: (formValues) => new Promise((resolve) => {
    
    setTimeout(resolve, 1000);
  }),
  saleDetails: {},
  setSubmitRef: () => {
  },
  commonFormComponents: () => null,
};
export default React.memo(AbstractSaleDetailsForm);
